<template>
  <v-container fluid>
    <v-layout wrap class="d-flex flex-column">
      <div md12 class="mx-2 d-flex align-center">
        <div class="text-h4 mt-4">App Home Feed</div>
      </div>
      <div md12 class="mx-2 d-flex align-center">
        <span class="mr-4">Language: </span>
        <v-radio-group v-model="selectedLanguage" @change="fetchData" row>
          <v-radio label="Thai" value="th"></v-radio>
          <v-radio label="English" value="en"></v-radio>
        </v-radio-group>
        <div style="flex-grow: 1"></div>
        <div class="mr-2">
          <v-btn @click="addSectionClick" color="primary"> <v-icon>mdi-plus</v-icon> Add </v-btn>
        </div>
        <div class="mr-2">
          <v-btn @click="fetchSections"> <v-icon>mdi-refresh</v-icon> Refresh </v-btn>
        </div>
        <div class="mr-2">
          <home-feed-trash
            :sections="deletedSections"
            :restore="restoreSection"
            :hardDelete="hardDeleteSection"
            :emptyTrash="emptyTrash"
          />
        </div>
      </div>
      <div md12 class="mx-2 d-flex">Section count: {{ sections.length }}</div>
      <div md12 class="mx-2">
        <div v-for="section in sections" :key="section.id">
          <home-feed-hero
            v-if="section.type === 'heroes'"
            :section="section"
            :moveUp="moveUp"
            :moveDown="moveDown"
            :onChildChange="fetchSections"
          />
          <home-feed-double-menu
            v-else-if="section.type === 'double_menus'"
            :section="section"
            :moveUp="moveUp"
            :moveDown="moveDown"
            :onChildChange="fetchSections"
            :deleteSection="softDeleteSection"
          />
          <home-feed-pending-action
            v-else-if="section.type === 'pending_action'"
            :section="section"
            :moveUp="moveUp"
            :moveDown="moveDown"
            :onChildChange="fetchSections"
            :deleteSection="softDeleteSection"
          />
          <home-feed-single-menu
            v-else-if="section.type === 'single_menus'"
            :section="section"
            :moveUp="moveUp"
            :moveDown="moveDown"
            :deleteSection="softDeleteSection"
          />
          <home-feed-assessment
            v-else-if="section.type === 'checkup_assessments'"
            :section="section"
            :moveUp="moveUp"
            :moveDown="moveDown"
          />
          <home-feed-triple-menu
            v-else-if="section.type === 'triple_menus'"
            :section="section"
            :moveUp="moveUp"
            :moveDown="moveDown"
            :onChildChange="fetchSections"
            :deleteSection="softDeleteSection"
          />
          <home-feed-book-now
            v-else-if="section.type === 'book_now'"
            :section="section"
            :moveUp="moveUp"
            :moveDown="moveDown"
          />
          <home-feed-guideline
            v-else-if="section.type === 'guidelines'"
            :section="section"
            :moveUp="moveUp"
            :moveDown="moveDown"
            :onChildChange="fetchSections"
          />
          <home-feed-fixed-provider
            v-else-if="section.type === 'top_providers'"
            :section="section"
            :moveUp="moveUp"
            :moveDown="moveDown"
          />
          <home-feed-fixed-provider
            v-else-if="section.type === 'recommended_providers'"
            heading="Recommended Providers (content is controlled by API)"
            :section="section"
            :moveUp="moveUp"
            :moveDown="moveDown"
            :deleteSection="softDeleteSection"
          />
          <home-feed-single-image
            v-else-if="section.type === 'single_image'"
            :section="section"
            :moveUp="moveUp"
            :moveDown="moveDown"
            :deleteSection="softDeleteSection"
          />
          <home-feed-social
            v-else-if="section.type === 'socials'"
            :section="section"
            :moveUp="moveUp"
            :moveDown="moveDown"
            :onChildChange="fetchSections"
          />
          <home-feed-discount-package
            v-else-if="section.type === 'discount_packages'"
            :section="section"
            :moveUp="moveUp"
            :moveDown="moveDown"
            :deleteSection="softDeleteSection"
          />
          <home-feed-end
            v-else-if="section.type === 'feed_end'"
            :section="section"
            :moveUp="moveUp"
            :moveDown="moveDown"
          />
          <v-card v-else elevation="2" outlined shaped tile class="my-4" color="red">
            <v-card-title>Unsupported Type: {{ section.type }}</v-card-title>
            <v-card-subtitle>
              <div>Sort Order: {{ section.sort_order }}</div>
              <div>Children Count: {{ section.children.length }}</div>
            </v-card-subtitle>
          </v-card>
        </div>
      </div>
    </v-layout>
    <v-dialog v-model="isShowAddDialog" max-width="600">
      <v-card>
        <v-card-title class="text-h5"> Add a new section </v-card-title>
        <v-card-subtitle class="mt-2">
          <div class="text-subtitle-2">Which type of section do you want to add?</div>
          <div>If you want to add a section that is not in the list, please contact tech team.</div>
        </v-card-subtitle>
        <v-card-text>
          <v-select label="Section Type" v-model="addingSectionType" :items="addingSectionTypes"></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="addNewSection" :disabled="!addingSectionType">Add</v-btn>
          <v-btn text color="error" @click="isShowAddDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import homefeedService from '../../services/homefeed';
import HomeFeedHero from './components/HomeFeedHero.vue';
import HomeFeedDoubleMenu from './components/HomeFeedDoubleMenu.vue';
import HomeFeedSingleMenu from './components/HomeFeedSingleMenu.vue';
import HomeFeedTripleMenu from './components/HomeFeedTripleMenu.vue';
import HomeFeedAssessment from './components/HomeFeedAssessment.vue';
import HomeFeedBookNow from './components/HomeFeedBookNow.vue';
import HomeFeedGuideline from './components/HomeFeedGuideline.vue';
import HomeFeedFixedProvider from './components/HomeFeedFixedProvider.vue';
import HomeFeedSingleImage from './components/HomeFeedSingleImage.vue';
import HomeFeedSocial from './components/HomeFeedSocial.vue';
import HomeFeedEnd from './components/HomeFeedEnd.vue';
import HomeFeedPendingAction from './components/HomeFeedPendingAction.vue';
import HomeFeedTrash from './components/HomeFeedTrash.vue';
import HomeFeedDiscountPackage from './components/HomeFeedDiscountPackage.vue';
import store from '../../store';
export default Vue.extend({
  store,
  components: {
    HomeFeedHero,
    HomeFeedDoubleMenu,
    HomeFeedSingleMenu,
    HomeFeedTripleMenu,
    HomeFeedAssessment,
    HomeFeedBookNow,
    HomeFeedGuideline,
    HomeFeedFixedProvider,
    HomeFeedSingleImage,
    HomeFeedSocial,
    HomeFeedEnd,
    HomeFeedPendingAction,
    HomeFeedTrash,
    HomeFeedDiscountPackage,
  },
  data: () => ({
    selectedLanguage: 'th',
    sections: [],
    deletedSections: [],
    isShowAddDialog: false,
    addingSectionType: null,
    addingSectionTypes: [
      { text: 'Single Image', value: 'single_image' },
      { text: 'Single Menu', value: 'single_menus' },
      { text: 'Double Menu', value: 'double_menus' },
      { text: 'Triple Menu', value: 'triple_menus' },
      { text: 'Discount Packages', value: 'discount_packages' },
      { text: 'Recommended Providers', value: 'recommended_providers' },
    ],
  }),
  watch: {},
  created() {},
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.fetchSections();
      this.fetchDeletedSections();
    },
    fetchSections() {
      homefeedService
        .fetchSections(this.selectedLanguage)
        .then((sections) => {
          this.sections = sections;
        })
        .catch((error) => {
          console.error('Error fetching sections:', error);
        });
    },
    fetchDeletedSections() {
      homefeedService
        .fetchTrash(this.selectedLanguage)
        .then((sections) => {
          this.deletedSections = sections;
        })
        .catch((error) => {
          console.error('Error fetching deleted sections:', error);
        });
    },
    moveUp(sectionId) {
      this.$root
        .$confirm('Move section up', `This change will take effect on app immediately.`, { color: 'primary' })
        .then((confirm) => {
          if (confirm) {
            homefeedService
              .moveSection(sectionId, -1)
              .then(() => {
                this.fetchSections();
              })
              .catch((error) => {
                console.error('Error moving section up:', error);
              });
          }
        });
    },
    moveDown(sectionId) {
      this.$root
        .$confirm('Move section down', `This change will take effect on app immediately.`, { color: 'primary' })
        .then((confirm) => {
          if (confirm) {
            homefeedService
              .moveSection(sectionId, 1)
              .then(() => {
                this.fetchSections();
              })
              .catch((error) => {
                console.error('Error moving section down:', error);
              });
          }
        });
    },
    addSectionClick() {
      this.addingSectionType = null;
      this.isShowAddDialog = !this.isShowAddDialog;
    },
    addNewSection() {
      this.isShowAddDialog = false;
      homefeedService
        .addSection(this.addingSectionType, this.selectedLanguage)
        .then(() => {
          this.fetchSections();
        })
        .catch((error) => {
          console.error('Error adding new section:', error);
        });
    },
    softDeleteSection(sectionId) {
      this.$root
        .$confirm('Remove section', `Are you sure to remove this section?`, { color: 'error' })
        .then((confirm) => {
          if (confirm) {
            homefeedService
              .softDeleteSection(sectionId)
              .then(() => {
                this.fetchData();
              })
              .catch((error) => {
                console.error('Error deleting section:', error);
              });
          }
        });
    },
    hardDeleteSection(sectionId) {
      this.$root
        .$confirm('Permanently delete section', `This action cannot be undone. Are you sure?`, { color: 'error' })
        .then((confirm) => {
          if (confirm) {
            homefeedService
              .deleteSection(sectionId)
              .then(() => {
                this.fetchData();
              })
              .catch((error) => {
                console.error('Error hard deleting section:', error);
              });
          }
        });
    },
    restoreSection(sectionId) {
      this.$root
        .$confirm('Restore section', `Are you sure to restore this section?`, { color: 'primary' })
        .then((confirm) => {
          if (confirm) {
            homefeedService
              .restoreSection(sectionId)
              .then(() => {
                this.fetchData();
              })
              .catch((error) => {
                console.error('Error restoring section:', error);
              });
          }
        });
    },
    emptyTrash() {
      this.$root
        .$confirm('Empty Trash', `This action cannot be undone. Are you sure?`, { color: 'error' })
        .then((confirm) => {
          if (confirm) {
            homefeedService
              .emptyTrash(this.selectedLanguage)
              .then(() => {
                this.fetchData();
              })
              .catch((error) => {
                console.error('Error emptying trash:', error);
              });
          }
        });
    },
  },
});
</script>

<style scoped></style>
